import { r } from './useApi';
import { keeper } from './utils';

export const getBackendServerInfo = async () => {
    const res = await r({
        endpoint: `${keeper('apiUrl')}/actuator/info`,
    });
    return res;
};

export const getFileStorageServerInfo = async () => {
    const res = await r({
        endpoint: `${keeper('fileStorageApiUrl')}/actuator/info`,
    });
    return res;
};

export const pingBackendServer = async () => {
    const res = await r({
        endpoint: `${keeper('apiUrl')}/actuator/health`,
    });
    return res;
};

export const pingFileStorageServer = async () => {
    const res = await r({
        endpoint: `${keeper('fileStorageApiUrl')}/actuator/health`,
    });
    return res;
};

export const useStats = () => {
    return {
        getBackendServerInfo: getBackendServerInfo,
        getFileStorageServerInfo: getFileStorageServerInfo,
        pingBackendServer: pingBackendServer,
        pingFileStorageServer: pingFileStorageServer,
    };
};

export default useStats;
